import { render, staticRenderFns } from "./TopPlayersList.vue?vue&type=template&id=94e0a418&scoped=true&"
import script from "./TopPlayersList.vue?vue&type=script&lang=js&"
export * from "./TopPlayersList.vue?vue&type=script&lang=js&"
import style0 from "./TopPlayersList.vue?vue&type=style&index=0&id=94e0a418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e0a418",
  null
  
)

export default component.exports